export const convertFileToBlob = file => {
  const blob = new Blob([file], { type: file.type });
  return blob;
};
